@let i = item();
<div class="toast-stack-item" (click)="onClick($event)">

    @if (i.component; as component) {
    <ng-container *ngComponentOutlet="component; inputs: i.componentInputs" />
} @else {
    @if (i.icon; as icon) {
        <pnyc-icon class="toast-stack-item__icon" [iconName]="icon"></pnyc-icon>
    }

    @if (i.message; as message) {
        <span class="toast-stack-item__message">{{ message }}</span>
    }
}

@if (i.hasClose) {
    <pnyc-button (clicked)="onClose($event)" [iconName]="'close'"></pnyc-button>
}
</div>